import {SET_ORDER_COMPLETE} from '../actions/action-types';

export const initialState = {
  aBIsClarusPositionOnPageExperiment: false,
  trackingDataCountryCode: '',
  trackingDataCustomerLocation: '',
  mobile: false,
  popUpId: '',
  bannerId: '',
  mobilePopUpId: '',
  mobileBannerId: '',
  unsecureHomePageUrl: '',
};

const orderCompleteReducer = (state = initialState, action) => {
  if (action.type === SET_ORDER_COMPLETE) {
    return {...state, ...action.values};
  }
  return state;
};

export default orderCompleteReducer;
